import React, { useEffect } from "react";
import { Table, Switch, Badge } from "antd";
import { Lock, Check, X } from "lucide-react";
import "./RolesPermissions.css";
import { ALL_PERMISSION_PAGES } from "../../Config";
import PermissionManager from "../../managers/PermissionManager";


const getDefaultActionLabel = (action) =>
({
  canRead: "View",
  canCreate: "Create",
  canUpdate: "Edit",
  canDelete: "Delete",
  canPublish: "Publish",
  canUpload: "Upload"
}[action] || action);

const getRoleEffectivePermission = (role, recordID, action) => {
  if (!role) return false;
  const permission = role.permissions.find((p) => p.id === recordID);
  if (!permission) return false;
  return !!permission[action];
};

const PermissionMatrix = ({
  role,
  getEffectivePermission,
  isPermissionLocked = () => false,
  hasOverride = () => false,
  toggleBrandOverride = () => { },
  togglePermission = () => { },
  getActionLabel,
  isReadOnly = false,
  isBrandOverride = false
}) => {
  


  useEffect(() => {
    console.log("PermissionMatrix mounted with role:", role);
  }, [role]);

  const isMenuLocked = (menuName) => {
    //check all actionKeys if isPermissionLocked(menuName, action) is true
    for (let action of PermissionManager.actionKeys) {
      if (isPermissionLocked(menuName, action)) {
        return true;
      }
    }
    return false;
    //     
  }

  const columns = [
    {
      title: "Page",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        console.log("Rendering permission name:", text, record);
        return <div className="permission-name">
          <span>{text}</span>
          {isMenuLocked(record.name) && (
            <Badge
              count="Locked by plan"
              style={{ backgroundColor: "#ccc", marginLeft: 8 }}
            />
          )}
        </div>
      }
    },
    ...PermissionManager.actionKeys.map((action) => ({
      title: getActionLabel ? getActionLabel(action) : getDefaultActionLabel(action), // 👈 maps CanRead → "View"
      dataIndex: action,
      key: action,
      align: "center",
      render: (_, record) => {
        const hasAction = action in record;
        const isLocked = isPermissionLocked(record.id, action);//isPermissionLocked(record.name, action);
        const isOverridden = isBrandOverride && hasOverride(record.id, action);

        let isEnabled = false;
        let toggleFn;
        if (isReadOnly) {
          isEnabled = getEffectivePermission ? getEffectivePermission(role.id, record.id, action) : getRoleEffectivePermission(role, record.id, action);
        } else if (isBrandOverride) {
          isEnabled = getEffectivePermission(role.id, record.id, action);
          toggleFn = () => toggleBrandOverride(role.id, record.id, action);
        } else {
          isEnabled = hasAction && !isLocked ? record[action] : false;
          toggleFn = () => togglePermission(role.id, record.id, action);
        }

        return hasAction ? (
          <div className="permission-cell">
            {isReadOnly ? (
              <div
                className={`status-dot ${isLocked ? "locked" : isEnabled ? "allowed" : "disabled"
                  }`}
              >
                {isLocked ? (
                  <Lock size={12} />
                ) : isEnabled ? (
                  <Check size={12} />
                ) : (
                  <X size={12} />
                )}
              </div>
            ) : (
              <Switch
                checked={isEnabled}
                onChange={toggleFn}
                disabled={isLocked}
                size="small"
              />
            )}
            {isOverridden && (
              <Badge
                count="Override"
                style={{ backgroundColor: "#f0ad4e", marginLeft: 4 }}
              />
            )}
          </div>
        ) : (
          <span>—</span>
        );
      }
    }))
  ];

  var dataSource = [...role.permissions];
  if (!isReadOnly) {
    dataSource = PermissionManager.getAllPermiossionsInactive().map(baseItem => {
      const override = role.permissions.find(o => o.id === baseItem.id);
      return override ? { ...baseItem, ...override } : baseItem;
    });
  }

  dataSource = dataSource.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      rowKey="id"
      pagination={false}
    />
  );
};

export default PermissionMatrix;
